// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","2076":"common","9777":"recorder"}[chunkId] || chunkId) + ".js";
};